module.exports = __webpack_public_path__ + "static/media/data-validate-hfm.297ad3bb.svg";